import { CLEAR_USER_DOCUMENT_DATA, GET_USER_DOCUMENT_DATA } from "../../constants/userDocument/UserDocument"


const initialState = {
    UserDocumentData: null
}
export const GetUserDocumentDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_USER_DOCUMENT_DATA:
            return {
                ...state,
                UserDocumentData: action.payload,
            }
        case CLEAR_USER_DOCUMENT_DATA:
            return {
               ...state,
               UserDocumentData: null,
            }
        default:
            return state
    }
}  